import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * BackBar — a clearly visible "← Back" button shown ABOVE the page content.
 * Mike specifically asked for this so seniors don't have to use the browser's
 * back arrow (which they sometimes mis-click into closing the tab).
 *
 * Behaviour:
 *  - If there's a previous history entry within this app, navigate(-1).
 *  - Otherwise fall back to the provided `fallback` route (default "/").
 */
export default function BackBar({ fallback = "/", label = "Back", className = "" }) {
  const nav = useNavigate();
  const loc = useLocation();

  const handleClick = () => {
    // window.history.length > 1 catches "we have somewhere to go back to"
    if (window.history.length > 1 && loc.key !== "default") {
      nav(-1);
    } else {
      nav(fallback);
    }
  };

  return (
    <div className={`max-w-7xl mx-auto px-5 md:px-8 pt-4 ${className}`}>
      <button
        type="button"
        onClick={handleClick}
        data-testid="back-bar"
        className="inline-flex items-center gap-2 bg-white border-2 border-[#F39A1F]/40 text-red-wine hover:bg-white hover:border-[#F39A1F] px-4 py-2 rounded-md text-[12px] tracking-wider-cap font-bold uppercase transition shadow-sm"
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={2.5} />
        {label}
      </button>
    </div>
  );
}
